<div class="container-fluid pb-2" *ngIf="initComplete">
  <form [formGroup]="searchForm" *ngIf="test" novalidate>

    <div class=" row p-0 m-0">
      <!-- <div class="col-md-{{codeKey.gridWidth}}" -->
      <!--add to [hidden] this.specificAppCodes.length==0 to avoid create same template for specificAppCodes -->
      <div [ngClass]="{'col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 pt-2': largeCol==true} "
        class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-2 pt-2" [hidden]="toggleFilter&&noSpecificAppCodes"
        *ngFor="let codeKey of appCodesKeys | arrayfilter: 'visible' : 1">
        <div *ngIf="codeKey.type=='selectize' && ! codeKey.multi && ! codeKey.staticFlagAppCode" data-toggle="tooltip"
          data-placement="right" data-html="true" [title]="forDebug ==1?codeKey.code:''">
          <sanabel-selectize [customPlaceHolder]="codeKey.placholderKey" [appcode]="codeKey.code"
            formControlName="{{codeKey.controlName  }}" [SearchKeys]="appCodesSearchKeys[codeKey.code]"
            (clicked)="onSelectizeClick($event , codeKey )" [simpleView]="false"
            [excludedCodes]="codeKey.excludedCodes?codeKey.excludedCodes:''">
          </sanabel-selectize>
        </div>
        <div *ngIf="codeKey.type=='selectize' && ! codeKey.multi && codeKey.staticFlagAppCode" data-toggle="tooltip"
          data-placement="right" data-html="true" [title]="forDebug ==1?codeKey.code:''">
          <sanabel-selectize [disabled]="true" [customPlaceHolder]="codeKey.placholderKey" [appcode]="codeKey.code"
            formControlName="{{codeKey.controlName  }}" [SearchKeys]="appCodesSearchKeys[codeKey.code]"
            (clicked)="onSelectizeClick($event , codeKey )"
            [excludedCodes]="codeKey.excludedCodes?codeKey.excludedCodes:''" [simpleView]="false">
          </sanabel-selectize>
        </div>
        <div *ngIf="codeKey.type=='selectize' && codeKey.multi" data-toggle="tooltip" data-placement="right"
          data-html="true" [title]="forDebug ==1?codeKey.code:''">
          <sanabel-selectize [appcode]="codeKey.code" [customPlaceHolder]="codeKey.placholderKey"
            formControlName="{{codeKey.controlName + 'Arr'}}" [multi]="true"
            [SearchKeys]="appCodesSearchKeys[codeKey.code]" (addSelected)="onSelected($event , codeKey )"
            [excludedCodes]="codeKey.excludedCodes?codeKey.excludedCodes:''"
            (clicked)="onSelectizeClick($event , codeKey )" [simpleView]="false">
          </sanabel-selectize>
        </div>
        <!-- addSelected -->
        <div *ngIf="codeKey.type=='text'" class="" data-toggle="tooltip" data-placement="right" data-html="true"
          [title]="forDebug ==1?codeKey.code:''">
          <label>{{codeKey.placholderKey | translate}}</label>
          <input #inputCustom class="form-control form-control-sm" placeholder="{{codeKey.placholderKey | translate}}"
            [type]="codeKey.type" formControlName="{{codeKey.controlName}}" />
        </div>
        <div *ngIf="codeKey.type=='numbersOnly'" class="" data-toggle="tooltip" data-placement="right" data-html="true"
          [title]="forDebug ==1?codeKey.code:''">
          <label>{{codeKey.placholderKey | translate}}</label>
          <input numbersOnly class="form-control form-control-sm" placeholder="{{codeKey.placholderKey | translate}}"
            formControlName="{{codeKey.controlName}}" />
        </div>
        <div *ngIf="codeKey.type=='date'" id="divOfDate" data-toggle="tooltip" data-placement="right" data-html="true"
          [title]="forDebug ==1?codeKey.code:''">
          <label class="mb-2">{{codeKey.placholderKey | translate}}</label>
          <div class="input-group input-group-sm" data-toggle="tooltip" data-placement="right" data-html="true"
            [title]="forDebug ==1?codeKey.code:''">
            <input #input class="form-control" placeholder="{{'DATEFORMAT' | translate}}"
              formControlName="{{codeKey.controlName}}" ngbDatepicker #d="ngbDatepicker" style="height: auto;" />
            <div class="input-group-addon" (click)="d.toggle()">
              <i class="fa fa-calendar"></i>
            </div>
          </div>
        </div>
        <!-- add BY Eng/Mostafa  To search By Date And Hour -->
        <div *ngIf="codeKey.type=='dateTime'" id="divOfDateTime" data-toggle="tooltip" data-placement="right"
          data-html="true" [title]="forDebug ==1?codeKey.code:''">
          <label class="mb-2">{{codeKey.placholderKey | translate}}</label>
          <div class="input-group input-group-sm" data-toggle="tooltip" data-placement="right" data-html="true"
            [title]="forDebug ==1?codeKey.code:''">
            <input #input type="datetime-local" id="emrPatNutritionTypesObj.doseDateTime" class="datetime-local"
              name="emrPatNutritionTypesObj.doseDateTime" formControlName="{{codeKey.controlName}}">
          </div>
        </div>
        <div *ngIf="codeKey.type=='radio'" data-toggle="tooltip" data-placement="right" data-html="true"
          [title]="forDebug ==1?codeKey.code:''"></div>
        <div *ngIf="codeKey.type=='hidden'" data-toggle="tooltip" data-placement="right" data-html="true"
          [title]="forDebug ==1?codeKey.code:''">
          <label hidden>{{codeKey.placholderKey | translate}}</label>
          <input hidden numbersOnly class="form-control form-control-sm"
            placeholder="{{codeKey.placholderKey | translate}}" formControlName="{{codeKey.controlName}}" />
        </div>
        <div *ngIf="codeKey.type=='labsearch'" class="mt-4">
          <button class="btn btn-success mt-2 rounded-0" (click)="labSearchPopup()">{{codeKey.placholderKey |
            translate}}</button>
        </div>
        <div *ngIf="codeKey.type=='checkbox'" data-toggle="tooltip" data-placement="right" data-html="true"
          [title]="forDebug ==1?codeKey.code:''">
          <div class="col-sm-10">
            <div class="form-group pt-1">
              <label class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" placeholder="{{codeKey.placholderKey | translate}}"
                  formControlName="{{codeKey.controlName}}">
                <span class="custom-control-indicator"></span>
                <span style="font-size: .9em;" class="customcontroldescription">{{codeKey.placholderKey
                  | translate}}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- fast search input  area  -->
      <div class="col-12 col-sm-5 col-md-4 col-lg-3 col-xl-2 p-0 pt-1" [hidden]="!toggleFilter">
        <label *ngIf="simpleViewFlag" class="w-100">
          {{ 'FASTSEARCH'| translate }}
        </label>
        <div *ngIf="!placeholderText"
          [ngStyle]="{'padding-top': simpleViewFlag === false ? '28px' : (simpleViewFlag === true? '0px' : '28px')}">
          <input #inputFastSearch class="form-control form-control-sm" (focus)="onFastSearchDataFocus()"
            formControlName="fastSearchData" placeholder="{{ 'FASTSEARCH' | translate }}" type="text"
            (keydown.enter)="onKeydown($event)" autofocus>
        </div>
        <div *ngIf="placeholderText"
          [ngStyle]="{'padding-top': simpleViewFlag === false ? '28px' : (simpleViewFlag === true? '0px' : '28px')}">
          <input #inputFastSearch class="form-control form-control-sm" (focus)="onFastSearchDataFocus()"
            formControlName="fastSearchData" placeholder="{{ placeholderText }}" type="text" autofocus>
        </div>
      </div>


      <div class="col d-flex pt-1">
        <div class="btn-group align-self-center">
          <button [hidden]="fastSearchAvalability == false" *ngIf="showFilterIcon" type="button" class="btn btn-success"
            style="background-color: #089da1;border-radius: 50%;" id="filterBtn" (click)="toggleFilterArea()"
            ngbTooltip="Show Filter">
            <i class="fa fa-filter fa-lg" aria-hidden="true"></i>
          </button>
          <button *ngIf="!toggleFilter" type="button" class="btn btn-success" (click)="refershSearchCritia()"
            style="background-color: #089da1;border-radius: 50%;" id="refreshBtn" ngbTooltip="refreshLoad">
            <i class="fa fa-refresh" aria-hidden="true"></i>
          </button>
          <button class="btn btn-primary" title="{{ 'SEARCH' | translate }}" placement="top" ngbTooltip="search "
            style="background-color: #089da1;border-radius: 50%;" id="searchBtn" (click)="onSearchClick()">
            <i class="fa fa-search"></i>
          </button>
          <button class="btn btn-primary" title="{{ 'EXPORT' | translate }}" placement="top" ngbTooltip="export "
            *ngIf="appearExport != false && !toggleFilter" style="background-color: #089da1;border-radius: 50%;"
            id="exportBtn" (click)="onExportClick()">
            <i class="fa fa-file-excel-o" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>

  </form>
  <div *ngIf="reportInfo" class="mt-2 position-absolute" style="left: 8px;bottom: 5px;">
    <span class="fa fa-info-circle cursor-pointer text-info" style="font-size: 32px" (click)="labSearchPopup(2)"></span>
    <span class="fa fa-file-pdf-o cursor-pointer" style="font-size:30px;color:red"
      (click)="DownloadExplanationReportPdf()"></span>
  </div>

</div>

<div></div>
<block-modal-container #content (close)=onModalClose($event)>
  <ng-container class="modal-body">
    <lab-search *ngIf="compType == 1"></lab-search>
    <fieldset>
      <legend class=" infoleg border border-secondary rounded"
        style=" text-align: center;text-decoration: bold; color: blue;"> معلومات خاصة بالتقرير </legend>
      <div class="info reinfo border border-primary rounded" *ngIf="compType == 2"
        [innerHTML]="replaceNewlinesWith(reportInfo)">
      </div>
    </fieldset>
  </ng-container>
</block-modal-container>


<!--<div class="col-md-3">
        <button class="button button-search" title="{{ 'SEARCH' | translate }}"
                placement="top" ngbTooltip="search "
                (click)="onSearchClick()">
          <i class="fa fa-search"></i>
        </button>
        <button class="button button-search adv-search-button"
                [hidden]="fastSearchAvalability == false" type="button"
                (click)="toggleFilterArea()"
                ngbTooltip="Show Filter">
            بحث متقدم  <i class="fa fa-filter fa-lg" aria-hidden="true"></i>
        </button>-->